export const NOW_SHIP_MAX_ANIMATION_DISTANCE = 5; // km

export const NOW_SHIP_MAX_ANIMATION_STEP = 100;

export const NOW_SHIP_ANIMATION_STEP_DURATION = 50; // ms

export const NOW_SHIP_LOCK_AUTO_MOVE_MAP_DURATION = 7000; // ms

// 环境域名
export const HOST = /share\.([^.]+\.)?shopeefood\.(?:vn?\.)?([^.]+)/;

// 当前 URL 信息
function getUrlData () {
  const match = window.location.host.match(HOST);
  const search = new URLSearchParams(window.location.search);
  return {
    env: match?.[1]?.slice(0, -1), // 去除点
    country: match?.[2],
    debugTool: search.get('debug_tool'),
    region: search.get('region')?.toLowerCase(),
    lang: search.get('lang')?.toLowerCase(),
    mock: search.get('mock'),
  };
}

const { env, country, debugTool, mock, lang, region } = getUrlData();
export const ENV = env;
export const COUNTRY = country;
export const DEBUG_TOOL = debugTool;
export const MOCK = mock;
export const LANG = lang;
export const REGION = region;
export const IS_DEV = process.env.NODE_ENV === 'development';

// 是否在非生产环境
export const IS_NON_LIVE =
  IS_DEV || ['test', 'uat', 'staging'].includes(env?.toLowerCase() || '');
